import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BlockUiService {
  private readonly _isBlocked = signal(false);
  readonly isBlocked = this._isBlocked.asReadonly();

  block(): void {
    this._isBlocked.set(true);
  }

  unblock(): void {
    this._isBlocked.set(false);
  }
}
